import { Component } from 'react';
import classnames from 'classnames';
import { Typography, TypographyProps } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import APHeadingStyle from './styles/APHeading.style';

interface APHeadingProps extends WithStyles<typeof APHeadingStyle> {
  className?: string
}

class APHeading extends Component<APHeadingProps & TypographyProps, {}> {
  render() {
    const {
      classes,
      className,
      ...otherProps
    } = this.props;

    const containerCls = classnames(className, classes.headingContainer);

    return (
      <Typography className={containerCls} {...otherProps} />
    );
  }
}

export default withStyles(APHeadingStyle)(APHeading);
